<template lang="html">
  
    <section class="card">
 
     <h4 >{{articulo.nombre}}</h4>
        <img v-bind:src="articulo.imagen" style="padding: 10px;width: 250px;height: 140px;">
        <p></p>
        <h7 id="articulo">{{articulo.descripcion}}</h7>
        <div><a>price: {{articulo.precio}}€</a> 
        <p></p>
        
        <button class="btn btn-success boton"   :disabled="articulo.stock<=0" v-on:click="anadirCarrito(articulo)" style="font-size:small; font-weight: 550;">Buy</button></div>
        
       <p style="color:rgb(131, 46, 46);font-size:small">stock:{{articulo.stock}}</p>
    
    
  </section>

</template>

<script lang="js">

 
import {db} from "./db"
import Firebase from "./db"
import Vue from 'vue'

export default  {
    name: 'card',
    props: ["articulo"],
  
    
    data () {
      return {
    userUID:"",
    documentos:[],
     user: {
          loggedIn: false,
          data: {}
        }

      }
    },

    mounted: function() {
      Firebase.auth.onAuthStateChanged( user => {
        if (user) {
          this.user.loggedIn = true;
          this.user.data = user;
          this.userUID=user.uid
        }
        else {
          this.user.loggedIn = false;
          this.user.data = {};
        }
      })
    },

  

    methods: {
        login() {
        Firebase.login();
      },
      logout() {
        Firebase.logout()
      },


      anadirCarrito(prod){

        if( this.user.loggedIn === false){

          document.getElementById("inicioLogin").click()
        }

        else{
        
      var doc={
        cantidad:1,
        idCliente:this.userUID,
        nombre:prod.nombre,
        imagen:prod.imagen,
        precio:prod.precio,
        stock:prod.stock,
       
      }
      db.collection('carrito').add(doc)
      Vue.notify({
  group: 'foo',
  title: '¡Enhorabuena!',
  text: 'has añadido un producto a la cesta'
})
    }
      }
    },

   
    computed: {

    }
}


</script>

<style>
.card {
  padding: 20px;
  margin: 20px;
  min-width: 300px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: white;
  box-shadow: 5px 5px rgb(211, 211, 211, 0.5);
}

.card:hover {
  margin-top: -4px;
  transition: 0.3s;
}

.card:hover button {
  height: 35px;
  width: 55px;
  transition: 0.5s all ease-out;
}

.boton {
  background-image: url("./double-bubble-dark.png");
}

p {
  width: 100%;
  color: rgba(25, 25, 68, 0.623);
}

#articulo {
  color: rgb(104, 103, 103);
  background-color: rgba(25, 25, 68, 0.171);
  border-radius: 3px;
  padding-left: 4px;
  padding-right: 4px;
}
img {
  padding: 10px;
}
a {
  padding: 10px;
}
</style>




